export default function Contacts() {
  return (
    <div className="main_basket">
      <h1>This is Contacts page</h1>
    </div>
  );
}
